<template>
  <div>
    <div class="d-flex justify-content-between align-self-center my-4">
      <AGCLabel>
        <span class="title">銀行資料</span>
        <template v-slot:subLabel v-if="role === 'merchant'">
          <span>
            (如欲收取款項，請輸入以下資料。只限更改一次。如需更新銀行資料，請電郵至
            <a href="mailto:eCoupon@ulifestyle.com.hk">eCoupon@ulifestyle.com.hk</a>)</span
          >
        </template>
      </AGCLabel>
    </div>
    <AGCEditGroupInput
      v-model="inputVal.bankName"
      class="custom-dropdown"
      :fieldName="'bankName'"
      inputType='dropdown'
      label="銀行名稱"
      name="銀行名稱"
      disabled
      @is-save="bankInfo.bankName = true"
      :options="bankOptions"
      :readOnly="readOnly || !(!bankInfo.bankName || role === 'admin')"
    >
    </AGCEditGroupInput>
    <AGCEditGroupInput
      v-model="inputVal.bankAddress"
      :fieldName="'bankAddress'"
      label="銀行地址"
      name="銀行地址"
      rules="max:200"
      type="text"
      disabled
      @is-save="bankInfo.bankAddress = true"
      :readOnly="readOnly || !(!bankInfo.bankAddress || role === 'admin')"
    >
    </AGCEditGroupInput>
    <AGCEditGroupInput
      v-model="inputVal.bankNumber"
      :fieldName="'bankNumber'"
      label="戶口號碼"
      name="戶口號碼"
      rules="numeric"
      type="text"
      disabled
      @is-save="bankInfo.bankNumber = true"
      :readOnly="readOnly || !(!bankInfo.bankNumber || role === 'admin')"
    >
    </AGCEditGroupInput>
    <AGCEditGroupInput
      v-model="inputVal.bankUsername"
      :fieldName="'bankUsername'"
      label="戶口名稱"
      name="戶口名稱"
      rules="max:50"
      type="text"
      disabled
      @is-save="bankInfo.bankUsername = true"
      :readOnly="readOnly || !(!bankInfo.bankUsername || role === 'admin')"
    >
    </AGCEditGroupInput>
    <AGCEditGroupInput
      v-model="inputVal.bankRemark"
      :fieldName="'bankRemark'"
      label="備注"
      name="備注"
      type="text"
      disabled
      :inputType="'textarea'"
      @is-save="bankInfo.bankRemark = true"
      :readOnly="readOnly || !(!bankInfo.bankRemark || role === 'admin')"
    >
    </AGCEditGroupInput>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import AGCEditGroupInput from '../form/AGCEditGroupInput.vue';
import AGCLabel from '../form/AGCLabel.vue';

import formMixin from '../../mixins/form';
import vModelMixin from '../../mixins/v-model';

export default {
  mixins: [formMixin, vModelMixin],
  props: {
    readOnly: Boolean,
  },
  components: {
    AGCEditGroupInput,
    AGCLabel,
  },
  data: () => ({
    bankOptions: [
      { value: 'BOC', text: '中國銀行(香港)有限公司 BOC' },
      { value: 'HSBC', text: '香港上海滙豐銀行有限公司 HSBC' },
    ],
    bankInfo: {},
  }),
  computed: {
    ...mapGetters(['role']),
  },
  methods: {
    updateBankInfo() {
      this.bankInfo = { ...this.inputVal };
    },
  },
  mounted() {
    this.updateBankInfo();
  },
};
</script>

<style lang="scss" scoped>
  ::v-deep {
    .custom-dropdown {
      .custom-select {
        width: auto;
        font-size: 0.98em;
      }
    }
  }
</style>
